import React from 'react';

import Badge from './Badge';
import {
  COURSE_REQUEST_STATUS_BADGES,
  courseRequestStatusName,
} from '../../constants/CourseRequestStatusConstants';

// Shared by the list and the review screen, so a status reads the same in both.
const CourseRequestStatusBadge: React.FC<{ status: unknown }> = ({
  status,
}) => {
  const name = courseRequestStatusName(status);

  return (
    <Badge
      label={name ?? 'Unknown'}
      variant={name ? COURSE_REQUEST_STATUS_BADGES[name] : 'default'}
    />
  );
};

export default CourseRequestStatusBadge;
